import client from "./client";

// Both fyId (ObjectId) and financialYear (String e.g. "2025-26") are required.
// fyId      → used to query Transaction (YEA entries)
// financialYear → used to query MaintenanceBill + IEJournalEntry

export const fetchIESummary = (societyId, fyId, financialYear) =>
  client.get("/ie/summary", { params: { societyId, fyId, financialYear } });

export const fetchIEReport = (societyId, fyId, financialYear) =>
  client.get("/ie/report", { params: { societyId, fyId, financialYear } });

// Journal entries use financialYear (String) only
export const fetchJournalEntries = (societyId, financialYear) =>
  client.get("/ie/journal", { params: { societyId, financialYear } });

export const createJournalEntry = (payload) =>
  client.post("/ie/journal", payload);

export const updateJournalEntry = (id, payload) =>
  client.put(`/ie/journal/${id}`, payload);

export const deleteJournalEntry = (id) =>
  client.delete(`/ie/journal/${id}`);

// Classification uses financialYear (String) only
export const fetchLedgerClassifications = (societyId, financialYear) =>
  client.get("/ie/classification", { params: { societyId, financialYear } });

export const saveLedgerClassification = (payload) =>
  client.put("/ie/classification", payload);
